export default {
    state: {
    },
    mutations: {
        ANIMATION_ITEMS: (state) => {
            let items = document.querySelectorAll('.animation')
            if (items.length > 0) {
                window.addEventListener('scroll', animationOnScroll)
                function animationOnScroll() {
                    for (let i = 0; i < items.length; i++) {
                        let item = items[i],
                            itemHeight = item.offsetHeight,
                            itemOffset = offset(item).top,
                            animationStart = 4,

                            animItemPoint = window.innerHeight - itemHeight / animationStart;

                        if (itemHeight > window.innerHeight) {
                            animItemPoint = window.innerHeight - window.innerHeight / animationStart;
                        }
                        if ((pageYOffset > itemOffset - animItemPoint) && pageYOffset < (itemOffset + itemHeight)) {
                            item.classList.add('isAnimated')
                        }
                        // else {
                        //     item.classList.remove('isAnimated')
                        // }
                    }
                }
                function offset(el) {
                    let rect = el.getBoundingClientRect(),
                        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                        scrollTop = window.pageYOffset || document.documentElement.scrollTop
                    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
                }
                animationOnScroll()
            }
        }
    },
    actions: {
        SEARCH_ANIMATION_ITEMS ({commit}) {
            commit('ANIMATION_ITEMS')
        }
    },
    getters: {
    },
}
